export default "__VITE_ASSET__04UyDYg7__"